import React__default, { forwardRef } from 'react';
import { Emoji as Emoji$1 } from '../../primitives/internal/Emoji.mjs';
import { classNames } from '../../utils/class-names.mjs';

const Emoji = forwardRef(
  ({ className, ...props }, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement(Emoji$1, {
      className: classNames("lb-emoji", className),
      ...props,
      ref: forwardedRef
    });
  }
);

export { Emoji };
//# sourceMappingURL=Emoji.mjs.map
